import api from '@/utils/api'

export default {
    getRoles() {
        return api.get('user-roles')
    }
}
